import { ResumenCierre } from "./resumenCierre"
import { DataTable } from '../../comp/DataTableSimple'
import { TipoDato } from '../../utils/Constantes'
import { FormatNombreUsuario } from "../../utils/Formatter"

export const ResumenConStockToPrint = ({ datosCajero = [], datosCaja = [], datosStock = [] }) => {
    if (datosCajero.length) datosCajero[0].nombresYApellidosStr = FormatNombreUsuario(datosCajero[0])
    return <>
        <DataTable headers={['TXT_CAJERO']}
            types={[TipoDato.CADENA]}
            access={['nombresYApellidosStr']}
            data={datosCajero}
            size="small" />
        <br/><br/>
        <ResumenCierre datos={datosCaja} isLoading={false} toPrint={true}/>
        <br/><br/>
        <DataTable headers={['TXT_CODIGO', 'TXT_NOMBRE', 'TXT_STOCK']}
            types={[TipoDato.CODIGO, TipoDato.CADENA, TipoDato.CANTIDAD]}
            access={['codigo', 'nombre', 'cantidad']}
            data={datosStock}
            size="small" />
    </>
}